import utilities from '@/shared/utilities.service';
import { B2CClientService, BoliaMoney } from '@/b2c/shared/api/server-apis';

export type FuzzyMoney = Array<number> | Array<BoliaMoney | undefined>;

const normalizeFuzzyMoney = (money: FuzzyMoney): number[] => {
    return money.map((m) => {
        if (typeof m === 'number') {
            return m;
        } else {
            return m?.rawAmount ?? 0;
        }
    });
};

export function useCurrency() {
    const plus = async(...money: FuzzyMoney): Promise<BoliaMoney | undefined> => {
        const request = normalizeFuzzyMoney(money);
        const result = B2CClientService.plusCurrency(request).then(utilities.unwrapModel);
        return result ?? {} as BoliaMoney;
    };

    return {
        plus,
    };
}
